import { render, staticRenderFns } from "./post_recommend_user_list.vue?vue&type=template&id=a19d8fb8&scoped=true"
import script from "./post_recommend_user_list.vue?vue&type=script&lang=ts"
export * from "./post_recommend_user_list.vue?vue&type=script&lang=ts"
import style0 from "./post_recommend_user_list.vue?vue&type=style&index=0&id=a19d8fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19d8fb8",
  null
  
)

export default component.exports